const globalFormErrorMessages = {
    messageValueMissing: { code: '3-6-6360', text: 'Please fill out this field.' },
    messageValueMissingSelect: { code: '3-6-6360', text: 'Please select a value.' },
    messageValueMissingSelectMulti: { code: '3-6-6360', text: 'Please select at least one value.' },
    messageTypeMismatchEmail: { code: '3-6-6360', text: 'Please enter an email address.' },
    messageTypeMismatchURL: { code: '3-6-6360', text: 'Please enter a URL.' },
    messageTooShort: { code: '3-6-6360', text: 'Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.' },
    messageTooLong: { code: '3-6-6360', text: 'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.' },
    messagePatternMismatch: { code: '3-6-6360', text: 'Please match the requested format.' },
    messageBadInput: { code: '3-6-6360', text: 'Please enter a number.' },
    messageStepMismatch: { code: '3-6-6360', text: 'Please select a value that is a multiple from {step}.' },
    messageToMuchDec: { code: '3-6-6360', text: 'Invalid value indicated. Your input has been changed to {newValue}.' },
    messageStepAdjust: { code: '3-6-6360', text: 'The value you entered for this field is invalid. The value has been changed from {currentValue} to {newValue}' },
    messageRangeOverflow: { code: '3-6-6360', text: 'Please select a value that is no more than {max}.' },
    messageRangeUnderflow: { code: '3-6-6360', text: 'Please select a value that is no less than {min}.' },
    messageGeneric: { code: '3-6-6360', text: 'The value you entered for this field is invalid.' },
    messageUnequal: { code: '3-6-6360', text: 'The indicated values do not match.' }
};

const globalBasketMessages = {
    messageEmptyBasket: { code: '1-6-6220', text: 'Shopping cart is empty' },
    messageAddedToBasket: { code: '1-6-6221', text: 'added to the shopping cart' },
    quickOrderMessageTooShort: { code: '1-6-6222', text: 'At least %1 characters are required for a search.' }
};

const globalDeliveryMessages = {
    messageDeliveryTypeGeneral: { code: '1-6-6226', text: 'Delivery method changed' }
};

const globalPaymentMessages = {
    messagePaymentTypeCreditCard: { code: '1-6-6227', text: 'Payment type credit card' },
    messagePaymentTypeInvoice: { code: '1-6-6227', text: 'Payment type invoice' },
    messagePaymentTypeInAdvance: { code: '1-6-6227', text: 'Payment type advance payment' },
    messagePaymentTypeOnDelivery: { code: '1-6-6227', text: 'Payment type cash on delivery' },
    messagePaymentTypeGeneral: { code: '1-6-6227', text: 'Payment type changed' }
};

const globalCompareMessages = {
    messageHint: { code: '1-6-6240', text: '' }
};

const globalFavoriteMessages = {
    messageInvalidName: { code: '2-6-6270', text: 'Unable to create the wish list; the name is invalid.' },
    messageMaxLists: { code: '2-6-6277', text: 'Max. number of wish lists reached!' },
    messageMaxPositions: { code: '2-6-6278', text: 'Max. number of positions reached!' },
    messageDeleteConfirmation: { code: '2-6-6273', text: 'Do you really want to delete the wish list?' },
};

const globalAutocompleteMessages = {
    messageNoValueFound: { code: '1-6-6290', text: 'No match found!' }
};

const globalArticleMessages = {
    messageEmpty: { code: '1-6-6210', text: 'No items found!' }
};

const globalAccountMessages = {
    messageDelete: { code: '1-6-6200', text: 'Do you really want to delete this address?' },
    messageChangeSuccess: { code: '1-6-6200', text: 'Address successfully modified.' }
};

const globalGeneralMessages = {
    messageEmptyText: { code: '1-6-6290', text: 'The output was suppressed due to an empty text.' },
    messageOk: { code: '1-6-6290', text: 'Yes' },
    messageCancel: { code: '1-6-6290', text: 'No' },
    messageChange: { code: '1-6-6290', text: 'The selection was changed' },
    messageDefault: { code: '1-6-0000', text: '' },
    messageDefaultInfo: { code: '1-6-0000', text: '' },
    messageDefaultWarning: { code: '2-6-0000', text: '' },
    messageDefaultError: { code: '3-6-0000', text: '' },
    messageDefaultDebug: { code: '4-6-0000', text: '', }
};

const globalDirectSearchSuggestMessages = {
    messageTooShort: { code: '1-6-6260', text: 'At least 3 characters!' },
    messageResultEmpty: { code: '1-6-6260', text: 'No items found!' }
};

const globalFileuploadAreaMessages = {
    defaultMessage: { code: '1-6-2002', text: 'Store the files here to upload them' },
    fallbackMessage: { code: '2-6-2002', text: 'Your browser does not support drag&drop file uploads' },
    fallbackText: { code: '2-6-2002', text: 'Use the form to upload your files' },
    fileTooBig: { code: '2-6-2002', text: 'The file is too large. The maximum file size is {{maxFileSize}} MB' },
    invalidFileType: { code: '2-6-2002', text: 'Unable to upload files of this type' },
    responseError: { code: '3-6-2002', text: 'The server rejected your request with status {{statusCode}}' },
    cancelUpload: { code: '1-6-2002', text: 'Cancel upload' },
    cancelUploadConfirmation: { code: '1-6-2002', text: 'Cancel upload?' },
    removeFile: { code: '1-6-2002', text: 'Remove file' },
    maxFilesExceeded: { code: '2-6-2002', text: 'You are not allowed to upload any more files' },
    buttonBrowse: { code: '1-6-2002', text: 'Select files to upload' },
    uploadHint: { code: '1-6-2002', text: 'Drag files and folders here' }
};

const globalCheckoutMessages = {
    missingTerms: { code: '3-6-6230', text: 'Please accept the General terms and conditions.' },
    loadingCheckoutTitle: { code: '1-6-6260', text: 'Almost done!' },
    loadingCheckoutText: { code: '1-6-6261', text: 'The order is carried out. This can take a moment!' }
};

const globalHtmlErrorCodeMessages = {
    htmlErrorGeneral: { code: '3-6-6000', text: 'Something has gone wrong!' },
    htmlError401: { code: '3-6-6000', text: 'A valid authentication is required to process the request.' },
    htmlError403: { code: '3-6-6000', text: 'The request could not be processed due to missing authorization of the client.' },
    htmlError404: { code: '3-6-6000', text: 'The requested site does not exist.' },
    htmlError413: { code: '3-6-6000', text: 'The file is too large.' },
    htmlError415: { code: '3-6-6000', text: 'This media type is not supported.' },
    htmlError422: { code: '3-6-6000', text: 'Unable to display the requested site correctly.' },
    htmlError500: { code: '3-6-6000', text: 'Internal server error' },
    htmlError503: { code: '3-6-6000', text: 'The server is temporarily unavailable.' }
};

if (!window.opacc) {
    window.opacc = {};
}

export const formErrorMessages = Object.assign({}, globalFormErrorMessages, window.opacc.systemFormErrorMessages, window.projectFormErrorMessages, window.opacc.projectFormErrorMessages, window.opacc.tkFormErrorMessages);
export const basketMessages = Object.assign({}, globalBasketMessages, window.opacc.systemBasketMessages, window.projectBasketMessages, window.opacc.projectBasketMessages, window.opacc.tkBasketMessages);
export const compareMessages = Object.assign({}, globalCompareMessages, window.opacc.systemCompareMessages, window.projectCompareMessages, window.opacc.projectCompareMessages, window.opacc.tkCompareMessages);
export const favoriteMessages = Object.assign({}, globalFavoriteMessages, window.opacc.systemFavoriteMessages, window.projectFavoriteMessages, window.opacc.projectFavoriteMessages, window.opacc.tkFavoriteMessages);
export const articleMessages = Object.assign({}, globalArticleMessages, window.opacc.systemArticleMessages, window.projectArticleMessages, window.opacc.projectArticleMessages, window.opacc.tkArticleMessages);
export const generalMessages = Object.assign({}, globalGeneralMessages, window.opacc.systemGeneralMessages, window.projectGeneralMessages, window.opacc.projectGeneralMessages, window.opacc.tkGeneralMessages);
export const directSearchSuggestMessages = Object.assign({}, globalDirectSearchSuggestMessages, window.opacc.systemDirectSearchSuggestMessages, window.projectDirectSearchSuggestMessages, window.opacc.projectDirectSearchSuggestMessages, window.opacc.tkDirectSearchSuggestMessages);
export const fileuploadAreaMessages = Object.assign({}, globalFileuploadAreaMessages, window.opacc.systemFileuploadAreaMessages, window.projectFileuploadAreaMessages, window.opacc.projectFileuploadAreaMessages, window.opacc.tkFileuploadAreaMessages);
export const autocompleteMessages = Object.assign({}, globalAutocompleteMessages, window.opacc.systemAutocompleteMessages, window.projectAutocompleteMessages, window.opacc.projectAutocompleteMessages, window.opacc.tkAutocompleteMessages);
export const paymentMessages = Object.assign({}, globalPaymentMessages, window.opacc.systemPaymentMessages, window.projectPaymentMessages, window.opacc.projectPaymentMessages, window.opacc.tkPaymentMessages);
export const deliveryMessages = Object.assign({}, globalDeliveryMessages, window.opacc.systemDeliveryMessages, window.projectDeliveryMessages, window.opacc.projectDeliveryMessages, window.opacc.tkDeliveryMessages);
export const accountMessages = Object.assign({}, globalAccountMessages, window.opacc.systemAccountMessages, window.projectAccountMessages, window.opacc.tkAccountMessages);
export const checkoutMessages = Object.assign({}, globalCheckoutMessages, window.opacc.systemCheckoutMessages, window.projectCheckoutMessages, window.opacc.projectCheckoutMessages, window.opacc.tkCheckoutMessages);
export const htmlErrorCodeMessages = Object.assign({}, globalHtmlErrorCodeMessages, window.opacc.systemHtmlErrorCodeMessages, window.projectHtmlErrorCodeMessages, window.opacc.projectHtmlErrorCodeMessages, window.opacc.tkHtmlErrorCodeMessages);
